import React, { useState, useEffect } from "react";
import heroImage from "../Assets/heroImag.jpg";
import homeImg1 from "../Assets/homeImg1.jpg";
import homeImg2 from "../Assets/homeImg2.jpg";
import homeIcon1 from "../Assets/homeIcon1.png";
import homeIcon2 from "../Assets/homeIcon2.png";
import homeIcon3 from "../Assets/homeIcon3.png";
import homeIcon4 from "../Assets/homeIcon4.png";
import homeIcon5 from "../Assets/homeIcon5.png";
import homeIcon6 from "../Assets/homeIcon6.png";

const Home = () => {
  const [navbarHeight, setNavbarHeight] = useState();

  useEffect(() => {
    const navbar = document.getElementsByClassName("navbar2_component")[0];
    setNavbarHeight(navbar.offsetHeight);
  }, []);
  return (
    <div className="page-wrapper" style={{ paddingTop: navbarHeight }}>
      <div className="global-styles w-embed">
        <style
          dangerouslySetInnerHTML={{
            __html:
              '\n/* Focus state style for keyboard navigation for the focusable elements */\n*[tabindex]:focus-visible,\n  input[type="file"]:focus-visible {\n   outline: 0.125rem solid #4d65ff;\n   outline-offset: 0.125rem;\n}\n/* Get rid of top margin on first element in any rich text element */\n.w-richtext > :not(div):first-child, .w-richtext > div:first-child > :first-child {\n  margin-top: 0 !important;\n}\n/* Get rid of bottom margin on last element in any rich text element */\n.w-richtext>:last-child, .w-richtext ol li:last-child, .w-richtext ul li:last-child {\n\tmargin-bottom: 0 !important;\n}\n/* Prevent all click and hover interaction with an element */\n.pointer-events-off {\n\tpointer-events: none;\n}\n/* Enables all click and hover interaction with an element */\n.pointer-events-on {\n  pointer-events: auto;\n}\n/* Create a class of .div-square which maintains a 1:1 dimension of a div */\n.div-square::after {\n\tcontent: "";\n\tdisplay: block;\n\tpadding-bottom: 100%;\n}\n/* Make sure containers never lose their center alignment */\n.container-medium,.container-small, .container-large {\n\tmargin-right: auto !important;\n  margin-left: auto !important;\n}\n/* \nMake the following elements inherit typography styles from the parent and not have hardcoded values. \nImportant: You will not be able to style for example "All Links" in Designer with this CSS applied.\nUncomment this CSS to use it in the project. Leave this message for future hand-off.\n*/\n/*\na,\n.w-input,\n.w-select,\n.w-tab-link,\n.w-nav-link,\n.w-dropdown-btn,\n.w-dropdown-toggle,\n.w-dropdown-link {\n  color: inherit;\n  text-decoration: inherit;\n  font-size: inherit;\n}\n*/\n/* Apply "..." after 3 lines of text */\n.text-style-3lines {\n\tdisplay: -webkit-box;\n\toverflow: hidden;\n\t-webkit-line-clamp: 3;\n\t-webkit-box-orient: vertical;\n}\n/* Apply "..." after 2 lines of text */\n.text-style-2lines {\n\tdisplay: -webkit-box;\n\toverflow: hidden;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n}\n/* Adds inline flex display */\n.display-inlineflex {\n  display: inline-flex;\n}\n/* These classes are never overwritten */\n.hide {\n  display: none !important;\n}\n@media screen and (max-width: 991px) {\n    .hide, .hide-tablet {\n        display: none !important;\n    }\n}\n  @media screen and (max-width: 767px) {\n    .hide-mobile-landscape{\n      display: none !important;\n    }\n}\n  @media screen and (max-width: 479px) {\n    .hide-mobile{\n      display: none !important;\n    }\n}\n.margin-0 {\n  margin: 0rem !important;\n}\n.padding-0 {\n  padding: 0rem !important;\n}\n.spacing-clean {\npadding: 0rem !important;\nmargin: 0rem !important;\n}\n.margin-top {\n  margin-right: 0rem !important;\n  margin-bottom: 0rem !important;\n  margin-left: 0rem !important;\n}\n.padding-top {\n  padding-right: 0rem !important;\n  padding-bottom: 0rem !important;\n  padding-left: 0rem !important;\n}\n.margin-right {\n  margin-top: 0rem !important;\n  margin-bottom: 0rem !important;\n  margin-left: 0rem !important;\n}\n.padding-right {\n  padding-top: 0rem !important;\n  padding-bottom: 0rem !important;\n  padding-left: 0rem !important;\n}\n.margin-bottom {\n  margin-top: 0rem !important;\n  margin-right: 0rem !important;\n  margin-left: 0rem !important;\n}\n.padding-bottom {\n  padding-top: 0rem !important;\n  padding-right: 0rem !important;\n  padding-left: 0rem !important;\n}\n.margin-left {\n  margin-top: 0rem !important;\n  margin-right: 0rem !important;\n  margin-bottom: 0rem !important;\n}\n.padding-left {\n  padding-top: 0rem !important;\n  padding-right: 0rem !important;\n  padding-bottom: 0rem !important;\n}\n.margin-horizontal {\n  margin-top: 0rem !important;\n  margin-bottom: 0rem !important;\n}\n.padding-horizontal {\n  padding-top: 0rem !important;\n  padding-bottom: 0rem !important;\n}\n.margin-vertical {\n  margin-right: 0rem !important;\n  margin-left: 0rem !important;\n}\n.padding-vertical {\n  padding-right: 0rem !important;\n  padding-left: 0rem !important;\n}\n/* Apply "..." at 100% width */\n.truncate-width { \n\t\twidth: 100%; \n    white-space: nowrap; \n    overflow: hidden; \n    text-overflow: ellipsis; \n}\n/* Removes native scrollbar */\n.no-scrollbar {\n    -ms-overflow-style: none;\n    overflow: -moz-scrollbars-none; \n}\n.no-scrollbar::-webkit-scrollbar {\n    display: none;\n}\n',
          }}
        />
      </div>
      <div className="page-wrapper">
        <main className="main-wrapper">
          <header className="section_home_hero-header">
            <div className="padding-global">
              <div className="container-large">
                <div className="home_hero-header_content">
                  <div className="padding-section-large">
                    <div className="max-width-medium">
                      <div className="margin-bottom margin-small">
                        <h1 className="color-white">
                          Elevate Your Home Decor with Stylish Deco Design
                        </h1>
                      </div>
                      <p className="text-size-medium color-white">
                        Enhance the beauty and functionality of your living
                        space with our extensive range of home decor solutions.
                        From curtains and blinds to shades, drapes, and elegant
                        plantation shutters, we offer the perfect solution for
                        every style and budget, all crafted with premium
                        Australian materials.
                      </p>
                      <div className="margin-top margin-medium">
                        <div className="button-group">
                          <a href="/about" className="button w-button">
                            About
                          </a>
                          <a
                            href="/contact"
                            className="button is-secondary is-alternate w-button"
                          >
                            Contact
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="home_hero-header_background-image-wrapper">
              <div className="image-overlay-layer" />
              <img
                src={heroImage}
                loading="eager"
                alt=""
                className="home_hero-header_background-image"
              />
            </div>
          </header>
          <section className="section_home_feature">
            <div className="padding-global">
              <div className="container-large">
                <div className="padding-section-large">
                  <div
                    id="w-node-_075f8f66-63ba-ff7a-0ef4-cb2c10ef84d9-dd49243c"
                    data-w-id="075f8f66-63ba-ff7a-0ef4-cb2c10ef84d9"
                    style={{ opacity: 0 }}
                    className="top-to-bot-reveal"
                  >
                    <div className="w-layout-grid home_feature_component">
                      <div className="home_feature_content">
                        <div className="margin-bottom margin-small">
                          <h2 className="color-dark">
                            Elevate Your Living Spaces with Our Craftsmanship
                          </h2>
                        </div>
                        <p className="color-dark text-size-medium">
                          At Stylish Deco Design, we prioritize quality in
                          everything we offer. Our curtains, blinds, shades,
                          drapes, and elegant plantation shutters are crafted
                          with precision and care. Our dedication to excellence
                          ensures that your home enjoys the lasting beauty and
                          durability of our premium materials.
                        </p>
                        <div className="margin-top margin-medium">
                          <div className="button-group">
                            <a
                              href="/portfolio"
                              className="button is-secondary w-button"
                            >
                              Portfolio
                            </a>
                            <a
                              href="/services"
                              className="button is-link is-icon w-inline-block"
                            >
                              <div className="color-dark">Services</div>
                              <div className="icon-embed-xxsmall w-embed">
                                <svg
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 3L11 8L6 13"
                                    stroke="#10256a"
                                    strokeWidth="1.5"
                                  />
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      {window.innerWidth > 768 && (
                        <div className="home_feature_image-wrapper">
                          <img
                            src={homeImg1}
                            loading="lazy"
                            alt=""
                            className="home_feature_image"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section_home_benefits background-color-dark">
            <div className="padding-global">
              <div className="container-large">
                <div className="padding-section-large">
                  <div className="w-layout-grid home_benefits_component">
                    <div
                      data-w-id="1b976938-2990-825b-123f-4c8164da5b65"
                      style={{ opacity: 0 }}
                      className="home_benefits_content"
                    >
                      <div className="margin-bottom margin-small">
                        <h2 className="color-white">
                          Transform Your Space with Professional Window
                          Treatments
                        </h2>
                      </div>
                      <div className="margin-bottom margin-medium">
                        <p className="color-white text-size-medium">
                          At Stylish Deco Design, we're passionate about
                          transforming your living spaces into havens of
                          elegance and comfort. With years of experience in
                          window treatments, we specialize in creating custom
                          solutions that perfectly suit your unique style and
                          needs.
                        </p>
                      </div>
                      <div className="w-layout-grid home_benefits_item-list">
                        <div className="home_benefits_item">
                          <div className="margin-bottom margin-xsmall">
                            <img
                              src={homeIcon1}
                              loading="lazy"
                              alt=""
                              className="icon-1x1-medium"
                            />
                          </div>
                          <div className="margin-bottom margin-xsmall">
                            <h6 className="color-white">Tailored Elegance</h6>
                          </div>
                          <p className="color-white">
                            Elevate your home with our exquisite range of custom
                            curtains, blinds, and drapes. Each piece is
                            meticulously crafted to add a touch of
                            sophistication to your windows.
                          </p>
                        </div>
                        <div className="home_benefits_item">
                          <div className="margin-bottom margin-xsmall">
                            <img
                              src={homeIcon2}
                              loading="lazy"
                              alt=""
                              className="icon-1x1-medium"
                            />
                          </div>
                          <div className="margin-bottom margin-xsmall">
                            <h6 className="color-white">Functional Beauty</h6>
                          </div>
                          <p className="color-white">
                            Discover the perfect balance between form and
                            function with our selection of shades and shutters.
                            Our designs not only enhance your decor but also
                            provide privacy and light control.
                          </p>
                        </div>
                      </div>
                    </div>
                    {window.innerWidth > 768 && (
                      <div className="home_benefits_image-wrapper">
                        <img
                          src={homeImg2}
                          loading="lazy"
                          style={{ opacity: 0 }}
                          data-w-id="1b976938-2990-825b-123f-4c8164da5b89"
                          alt=""
                          className="home_benefits_image"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section_home_how-it-works">
            <div className="padding-global">
              <div className="container-large">
                <div className="padding-section-large">
                  <div className="w-layout-grid home_how-it-works_component top-to-bot-reveal">
                    <div
                      data-w-id="1b976938-2990-825b-123f-4c8164da5b8f"
                      style={{ opacity: 0 }}
                      className="home_how-it-works_content-left"
                    >
                      <h2 className="color-dark">
                        Easy Steps to Beautiful Window Treatments
                      </h2>
                      <div className="margin-top margin-medium">
                        <div className="button-group">
                          <a
                            href="/about"
                            className="button is-secondary w-button"
                          >
                            Get Started
                          </a>
                          <a
                            href="/services"
                            className="button is-link is-icon w-inline-block"
                          >
                            <div className="color-dark">Learn More</div>
                            <div className="icon-embed-xxsmall w-embed">
                              <svg
                                width={16}
                                height={16}
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6 3L11 8L6 13"
                                  stroke="#10256a"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      data-w-id="1b976938-2990-825b-123f-4c8164da5b9d"
                      style={{ opacity: 0 }}
                      className="home_how-it-works_content-right"
                    >
                      <div
                        data-w-id="1b976938-2990-825b-123f-4c8164da5b9e"
                        className="home_how-it-works_timeline-wrapper"
                      >
                        <div className="home_how-it-works_progress-bar-wrapper">
                          <div className="home_how-it-works_progress-bar" />
                        </div>
                        <div
                          data-w-id="1b976938-2990-825b-123f-4c8164da5ba1"
                          className="w-layout-grid home_how-it-works_timeline-step"
                        >
                          <div className="home_how-it-works_timeline-left">
                            <div className="home_how-it-works_timeline-icon-wrapper">
                              <img
                                src={homeIcon3}
                                loading="lazy"
                                alt=""
                                className="icon-1x1-medium"
                              />
                            </div>
                          </div>
                          <div className="home_how-it-works_timeline-right">
                            <div className="home_how-it-works_text-wrapper">
                              <div className="margin-bottom margin-xsmall">
                                <h6 className="color-dark">
                                  Discover Your Vision
                                </h6>
                              </div>
                              <p className="color-dark">
                                Begin your journey by exploring your design
                                preferences and sharing your vision with us.
                                Whether you have a clear idea or need
                                inspiration, we're here to assist you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          data-w-id="1b976938-2990-825b-123f-4c8164da5bac"
                          className="w-layout-grid home_how-it-works_timeline-step"
                        >
                          <div className="home_how-it-works_timeline-left">
                            <div className="home_how-it-works_timeline-icon-wrapper">
                              <img
                                src={homeIcon4}
                                loading="lazy"
                                alt=""
                                className="icon-1x1-medium"
                              />
                            </div>
                          </div>
                          <div className="home_how-it-works_timeline-right">
                            <div className="home_how-it-works_text-wrapper">
                              <div className="margin-bottom margin-xsmall">
                                <h6 className="color-dark">
                                  Schedule a Consultation
                                </h6>
                              </div>
                              <p className="color-dark">
                                Contact our expert team to schedule a
                                complimentary consultation. We'll assess your
                                space, discuss your preferences, and offer
                                personalized recommendations.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          data-w-id="1b976938-2990-825b-123f-4c8164da5bb7"
                          className="w-layout-grid home_how-it-works_timeline-step"
                        >
                          <div className="home_how-it-works_timeline-left">
                            <div className="home_how-it-works_timeline-icon-wrapper">
                              <img
                                src={homeIcon5}
                                loading="lazy"
                                alt=""
                                className="icon-1x1-medium"
                              />
                            </div>
                          </div>
                          <div className="home_how-it-works_timeline-right">
                            <div className="home_how-it-works_text-wrapper">
                              <div className="margin-bottom margin-xsmall">
                                <h6 className="color-dark">
                                  Expert Craftsmanship
                                </h6>
                              </div>
                              <p className="color-dark">
                                Our skilled artisans will handcraft your chosen
                                window treatments to perfection, ensuring every
                                detail aligns with your specifications.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          data-w-id="1b976938-2990-825b-123f-4c8164da5bc2"
                          className="w-layout-grid home_how-it-works_timeline-step"
                        >
                          <div className="home_how-it-works_timeline-left">
                            <div className="home_how-it-works_timeline-icon-wrapper">
                              <img
                                src={homeIcon6}
                                loading="lazy"
                                alt=""
                                className="icon-1x1-medium"
                              />
                            </div>
                          </div>
                          <div className="home_how-it-works_timeline-right">
                            <div className="home_how-it-works_text-wrapper">
                              <div className="margin-bottom margin-xsmall">
                                <h6 className="color-dark">
                                  Seamless Installation
                                </h6>
                              </div>
                              <p className="color-dark">
                                Sit back and relax as our experienced
                                technicians install your window treatments with
                                precision. Your space will be transformed with
                                style and functionality.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section_home_testimonial">
            <div className="padding-global">
              <div className="container-large">
                <div
                  data-w-id="1b976938-2990-825b-123f-4c8164da5bdd"
                  style={{ opacity: 0 }}
                  className="padding-section-large"
                >
                  <div
                    data-delay={4000}
                    data-animation="slide"
                    className="home_testimonial_component w-slider"
                    data-autoplay="false"
                    data-easing="ease"
                    data-hide-arrows="false"
                    data-disable-swipe="false"
                    data-autoplay-limit={0}
                    data-nav-spacing={3}
                    data-duration={500}
                    data-infinite="true"
                  >
                    <div className="home_testimonial_mask w-slider-mask">
                      <div className="home_testimonial_slide w-slide">
                        <div className="home_testimonial_content">
                          <div className="home_testimonial_rating-wrapper">
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="margin-vertical margin-medium">
                            <div className="color-dark heading-style-h5">
                              I had a great experience working with stylish deco
                              design. Their window treatments transformed my
                              home and added a touch of elegance. Highly
                              recommended!
                            </div>
                          </div>
                          <div className="home_testimonial_client">
                            <div className="home_testimonial_client-image-wrapper">
                              <img
                                src="images/placeholder-image.svg"
                                loading="lazy"
                                alt=""
                                className="home_testimonial_client-image"
                              />
                            </div>
                            <div className="home_testimonial_client-info">
                              <p className="color-dark text-weight-semibold">
                                John Doe
                              </p>
                              <p className="color-dark">Homeowner, ABC Inc.</p>
                            </div>
                            <div className="home_testimonial_divider" />
                            <div className="home_testimonial_logo-wrapper">
                              <img
                                src="images/logo-webflow.svg"
                                loading="lazy"
                                alt=""
                                className="home_testimonial_logo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="home_testimonial_slide w-slide">
                        <div className="home_testimonial_content">
                          <div className="home_testimonial_rating-wrapper">
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="home_testimonial_rating-icon">
                              <div className="icon-embed-xsmall w-embed">
                                <svg
                                  width="100%"
                                  viewBox="0 0 18 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.16379 0.551109C8.47316 -0.183704 9.52684 -0.183703 9.83621 0.551111L11.6621 4.88811C11.7926 5.19789 12.0875 5.40955 12.426 5.43636L17.1654 5.81173C17.9684 5.87533 18.294 6.86532 17.6822 7.38306L14.0713 10.4388C13.8134 10.6571 13.7007 10.9996 13.7795 11.3259L14.8827 15.8949C15.0696 16.669 14.2172 17.2809 13.5297 16.8661L9.47208 14.4176C9.18225 14.2427 8.81775 14.2427 8.52793 14.4176L4.47029 16.8661C3.7828 17.2809 2.93036 16.669 3.11727 15.8949L4.22048 11.3259C4.29928 10.9996 4.18664 10.6571 3.92873 10.4388L0.317756 7.38306C-0.294046 6.86532 0.0315611 5.87533 0.834562 5.81173L5.57402 5.43636C5.91255 5.40955 6.20744 5.19789 6.33786 4.88811L8.16379 0.551109Z"
                                    fill="#10256a"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="margin-vertical margin-medium">
                            <div className="color-dark heading-style-h5">
                              I had a great experience working with stylish deco
                              design. Their window treatments transformed my
                              home and added a touch of elegance. Highly
                              recommended!
                            </div>
                          </div>
                          <div className="home_testimonial_client">
                            <div className="home_testimonial_client-image-wrapper">
                              <img
                                src="images/placeholder-image.svg"
                                loading="lazy"
                                alt=""
                                className="home_testimonial_client-image"
                              />
                            </div>
                            <div className="home_testimonial_client-info">
                              <p className="color-dark text-weight-semibold">
                                John Doe
                              </p>
                              <p className="color-dark">Homeowner, ABC Inc.</p>
                            </div>
                            <div className="home_testimonial_divider" />
                            <div className="home_testimonial_logo-wrapper">
                              <img
                                src="images/logo-webflow.svg"
                                loading="lazy"
                                alt=""
                                className="home_testimonial_logo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="home_testimonial_arrow hide-mobile-landscape w-slider-arrow-left">
                      <div className="home_testimonial_arrow-icon w-embed">
                        <svg
                          width="100%"
                          height="100%"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.31066 8.75001L9.03033 14.4697L7.96967 15.5303L0.439339 8.00001L7.96967 0.469676L9.03033 1.53034L3.31066 7.25001L15.5 7.25L15.5 8.75L3.31066 8.75001Z"
                            fill="#10256a"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="home_testimonial_arrow hide-mobile-landscape w-slider-arrow-right">
                      <div className="home_testimonial_arrow-icon w-embed">
                        <svg
                          width="100%"
                          height="100%"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.6893 7.25L6.96967 1.53033L8.03033 0.469666L15.5607 8L8.03033 15.5303L6.96967 14.4697L12.6893 8.75H0.5V7.25H12.6893Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="home_testimonial_slide-nav w-slider-nav w-slider-nav-invert w-round" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <section className="section_cta13 background-color-dark">
          <div className="padding-global">
            <div className="container-large">
              <div className="padding-section-large">
                <div className="w-layout-grid cta13_component">
                  <div className="cta13_content-left">
                    <h2 className="color-white">
                      Transform Your Home with Style
                    </h2>
                  </div>
                  <div className="cta13_content-right">
                    <p className="color-white text-size-medium">
                      At Stylish Deco Design, we offer expert window treatment
                      solutions tailored to your needs. Whether you're looking
                      for curtains, blinds, shades, drapes, or shutters, we have
                      the perfect options to enhance the beauty and
                      functionality of your windows.
                    </p>
                    <div className="margin-top margin-medium">
                      <div className="button-group">
                        <a
                          href="/portfolio"
                          className="button is-secondary w-button dark-background-secondary"
                        >
                          Portfolio
                        </a>

                        <a
                          href="/contact"
                          className="button is-link is-icon w-inline-block"
                        >
                          <div className="color-white">Contact</div>
                          <div className="icon-embed-xxsmall w-embed">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 3L11 8L6 13"
                                stroke="#928686"
                                strokeWidth="1.5"
                              />
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
